var _defs, _path, _path2, _text, _line, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "51.52 37 788.59 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed1100;}.cls-2{font-size:26.57px;letter-spacing:0.03em;}.cls-2,.cls-7{fill:#4b4948;font-family:Avenir-Black, Avenir;font-weight:800;}.cls-3{letter-spacing:0.03em;}.cls-4{letter-spacing:-0.06em;}.cls-5{letter-spacing:0.03em;}.cls-6{fill:none;stroke:#4b4948;stroke-miterlimit:10;stroke-width:6px;}.cls-7{font-size:64px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.91,134.12l7.48-13.57a51,51,0,0,0,46.8-3.58,5.08,5.08,0,1,0-5.36-8.64A40.67,40.67,0,0,1,61.68,74.09a5.08,5.08,0,0,0-9.53-2.41,5,5,0,0,0-.63,2.49,50.92,50.92,0,0,0,22,41.47L66,129.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.51,83.81a20.73,20.73,0,0,0-4-25.15L124,45.1l-8.9-4.91-7.48,13.57a20.73,20.73,0,1,0,12.92,30.05Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(486.73 81.93)"
  }, "A MEDICAL COMMUNITY ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "POWERED BY "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 194.88,
    y: 30
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 208.46,
    y: 30
  }, "AKEDA")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 455,
    y1: 40,
    x2: 455,
    y2: 134
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(147.61 111.38)"
  }, "Med", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 137.47,
    y: 0
  }, "Unifi"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.e7357a9e.svg";
export { ForwardRef as ReactComponent };